import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { Checkbox } from "@components/inputs/shared";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { SportInteractionTypeEnum } from "@data-types/analytics-tracker/SportInteractionTypeEnum";
import OfferIcon from "@components/icons/Offer";
import { analyticsTracker } from "@utils/analytics";

export const SportItemButton = observer(function SportItemButton(props: {
	item: PrematchOfferMenuStore["menu"];
	store: {
		toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
	};
}) {
	if (props.item.node.abrv == null) {
		console.error("Expected item, got null.");
		return null;
	}

	const labelId = `sport-${props.item.node.id}`;

	return (
		<button
			className={classNames("nav--tertiary__link", {
				"is-expanded": props.item.isExpanded,
				"is-active": props.item.checkState === 1,
			})}
			type="button"
			onClick={(e) => {
				e.stopPropagation();
				props.item.toggleExpanded();
			}}
		>
			<span className="nav--tertiary__title">
				<span className="input--check input--check--sml">
					<Checkbox
						id={labelId}
						className="input--check__box input--check--sml__box"
						name={props.item.node.name}
						title={props.item.node.name}
						checked={props.item.checkState === 1}
						indeterminate={props.item.checkState === 2}
						onChange={(e) => {
							e.stopPropagation();
							if (props.store.toggleUpdateProcessing != null) {
								props.store.toggleUpdateProcessing();
							}
							props.item.onToggleCheck();
							if (props.item.checkState === 1) {
								analyticsTracker.trackSportInteraction(
									SportInteractionTypeEnum.LiveSport,
									props.item.node.abrv
								);
							}
							window.scrollTo(0, 0);
						}}
					/>
					<label
						htmlFor={labelId}
						className="input--check__label input--check--sml__label"
					/>
				</span>
				<OfferIcon
					type="sport"
					sport={props.item.node.abrv || ""}
					wrapperClassName="nav--tertiary__icon u-icon u-icon--base"
					className={"nav--tertiary__icon__inner u-icon--base"}
					treeIcon={true}
				/>
				<span>{props.item.node.name}</span>
			</span>
			<span className="nav--tertiary__counter counter counter--base">
				{props.item.node.count}
			</span>
		</button>
	);
});
